module.exports = __webpack_public_path__ + "static/media/video-bg1.0f728ac5.jpg";